import React, { useEffect } from 'react';
import fr from 'facet-rest';
import Uploader from 'Components/Files/Uploader';
import { useSnackbarContext } from 'Context/SnackbarContext';
import PropTypes from 'prop-types';
import AttachmentsList
  from 'Views/Page/Content/Templates/WizardTemplates/WizardAttachmentsTemplate/Content/AttachmentsList';
import { Box, PrimaryActionButton, Stack } from '@facet-wealth/design';
import Text from 'Components/ComponentLibrary/Atoms/Text';


export default function DocumentUploader({
  resource,
  setCollection,
  onAttachmentDelete,
  onAttachmentCreate,
}) {
  const { displayErrorMessage } = useSnackbarContext();
  const [isLoading, setIsLoading] = React.useState(false);
  const [relevantAttachments, setRelevantAttachments] = React.useState(null);
  const getRelevantAttachments = async () => {
    const documents = await resource.relationship(fr.relationships.relevantAttachments.name)?.link('related').get();
    setRelevantAttachments(documents);
  };

  useEffect(() => {
    getRelevantAttachments();
  }, []);

  const handleDelete = async attachment => {
    try {
      setIsLoading(true);
      await attachment.delete();

      if (onAttachmentDelete && typeof onAttachmentDelete === 'function') {
        onAttachmentDelete();
      }

      const documents = await resource.relationship(fr.relationships.relevantAttachments.name)?.link('related').get();
      setRelevantAttachments(documents);
      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  };

  return (
    <Box width={'100%'} padding={400}>
      <Stack direction={'column'} spacing={1} alignItems="flex-start" justifyContent="flex-start">
        <Box width={'100%'}>
          <Stack justifyContent={'space-between'} spacing={2} alignItems={'center'}>
            <Text
              value={resource.meta().field('hasAttachments').attr('prompt')}
              variant="h3"
              weight="medium"
              color={'textPrimary'}
            />
            {
              resource.withRelationship(
                fr.relationships.uploadWizard.name,
                () => (
                  <div test="attachment-button">
                    <PrimaryActionButton
                      icon={'attachFile'}
                      size="sm"
                      label={resource.attr('attachmentButtonText') || 'Upload'}
                      onClick={async () => {
                        const newItemCollection = await resource.relationship(fr.relationships.uploadWizard.name).link('related').get();
                        setCollection(newItemCollection);
                      }}
                      loading={isLoading}
                    />
                  </div>
                ),
                () => resource.withRelationship(
                  fr.relationships.uploadAttachment.name,
                  () => (
                    <Uploader
                      url={resource.relationship(fr.relationships.uploadAttachment.name).link('related').url()}
                      onStart={() => setIsLoading(true)}
                      onFinally={() => {
                        setIsLoading(false);
                      }
                    }
                      onSuccess={async () => {
                        const documents = await resource.relationship(fr.relationships.relevantAttachments.name).link('related').get();
                        setRelevantAttachments(documents);
                        await onAttachmentCreate();
                      }}
                      onCatch={err => {
                        setIsLoading(false);
                        displayErrorMessage(err, err.errors);
                      }}
                      successToastMessage=""
                      params={null}
                      disableClick={isLoading}
                    >
                      <div test="3120-upload-button">
                        <PrimaryActionButton
                          icon={'attachFile'}
                          size="sm"
                          label={resource.attr('attachmentButtonText') || 'Upload'}
                          loading={isLoading}
                        />
                      </div>
                    </Uploader>
                  ),
                  () => null,
                ),
              )
        }
          </Stack>
        </Box>
        <Box width={'100%'}>
          {relevantAttachments && <AttachmentsList attachments={relevantAttachments.resources().list()} onDelete={handleDelete} />}
        </Box>

      </Stack>
    </Box>
  );
}

DocumentUploader.defaultProps = {
  onAttachmentDelete: () => {},
  onAttachmentCreate: () => {},
};

DocumentUploader.propTypes = {
  resource: PropTypes.object.isRequired,
  setCollection: PropTypes.object.isRequired,
  onAttachmentDelete: PropTypes.func,
  onAttachmentCreate: PropTypes.func,
};
